import { render, staticRenderFns } from "./AulasPorVeiculo.vue?vue&type=template&id=63da6bf8&scoped=true"
import script from "./AulasPorVeiculo.vue?vue&type=script&lang=js"
export * from "./AulasPorVeiculo.vue?vue&type=script&lang=js"
import style0 from "./AulasPorVeiculo.vue?vue&type=style&index=0&id=63da6bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da6bf8",
  null
  
)

export default component.exports